import { render, staticRenderFns } from "./kpi-staff-register.vue?vue&type=template&id=7b594e28&scoped=true"
import script from "./kpi-staff-register.vue?vue&type=script&lang=js"
export * from "./kpi-staff-register.vue?vue&type=script&lang=js"
import style0 from "./kpi-staff-register.vue?vue&type=style&index=0&id=7b594e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b594e28",
  null
  
)

export default component.exports